import {i18n} from '../../i18n.config';

export const customLink = (lang: string, href: string) => {
  const isDefaultLang = lang === i18n.defaultLocale;
  const path = isDefaultLang ? href : `/${lang}${href}`;

  return path;
};
